import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { UpdateCustomerUserProjectsDto } from '@ansvar-sakerhet/api-client';
import { toast } from '../../../components/Toast';

export function useReplaceUserProjects() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async ({
    customerUserId,
    data,
  }: {
    customerUserId: string;
    data: UpdateCustomerUserProjectsDto;
  }) => {
    const api = await getApi();
    const res = await api.customerUserReplaceProjects(customerUserId, data);
    return res.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
    onError: () =>
      toast.error('Något gick fel när projektbehörigheten skulle uppdateras'),
  });
}
